export default __webpack_public_path__ + "static/media/home.a46fa6c3.svg";